module.exports = __webpack_public_path__ + "static/media/tiktok.c888201b.svg";